
export class AppSettings {
  public static App = 'opengolf';
  public static Base = '/admin/';       // <------------ prod
  public static URL = 'https://opengolf.it'; // è un altro URL rispetto al dominio attuale http://admin.my-ticket.it
  public static IMG_URL = 'https://opengolf.it/public';
  public static AVATAR_URL = 'https://opengolf.it/avatars';
  public static API_ENDPOINT = 'https://opengolf.it/core2/api';
  public static CHAT_ENDPOINT = 'https://opengolf.it/core2';
  public static GoogleClientId = '309619434515-0emgmiq9jafnk4185tags76ceti5k78h.apps.googleusercontent.com';
  public static GoogleAPIKey = 'AIzaSyDITn-wh-Sfp4iD3k0TFlkPzGbaysxseL0';
  // public static GoogleAPIKey = 'AIzaSyDITn-wh-Sfp4iD3k0TFlkPzGbaysxseL0'; // diamocitempo
  // public static GoogleAPIKey = 'AIzaSyBfZYZNv8eK1g8aVa2H543BZheX6Tf1gXY'; // opengolf
}
